import { CalculosApi } from '@common/api';
const FormulaService = {
  listar: function (parametros) {
    return CalculosApi.get()('/FormulaMensurando', parametros);
  },
  buscar: function (id, parametros) {
    return CalculosApi.get()(`/FormulaMensurando/${id}`, parametros);
  },
  salvar: function (form) {
    if (form.id)
      return CalculosApi.put()(`/FormulaMensurando/${form.id}`, form);
    return CalculosApi.post()('/FormulaMensurando', form);
  },
  excluir: function (id) {
    return CalculosApi.delete()(`/FormulaMensurando/${id}`);
  },
  validar: function (parametros) {
    return CalculosApi.post()('/FormulaMensurando/validar', parametros);
  },
  duplicar: function (id, novoSimbolo) {
    if (!novoSimbolo)
      return CalculosApi.post()(`/FormulaMensurando/${id}/duplicar`, {
        novoSimbolo: null,
      });
    return CalculosApi.post()(`/FormulaMensurando/${id}/duplicar`, novoSimbolo);
  },
  variaveis: function (id, parametros) {
    return CalculosApi.get()(`/FormulaMensurando/${id}/variaveis`, parametros);
  },
  buscarRevisao: function (idMensurando, idRevisao) {
    return CalculosApi.get()(
      `/FormulaMensurando/${idMensurando}/revisoes/${idRevisao}`
    );
  },
  listarDerivadas: function (idMensurando, parametros) {
    return CalculosApi.get()(`/FormulaMensurando/${idMensurando}/derivadas`, parametros)
  },
  listarFormulaDerivada: function(parametros) {
    return CalculosApi.get()('/FormulaMensurando/derivadas', parametros);
  },
  salvarDerivada: function (mensurandoId, form) {
    if (form.unidadeMedida) delete form.unidadeMedida;
    form.unidadeMedidaId = form.unidadeMedidaId.value;
    if (form.id)
      return CalculosApi.put()(
        `/FormulaMensurando/${mensurandoId}/derivadas/${form.id}`,
        form
      );
    return CalculosApi.post()(
      `/FormulaMensurando/${mensurandoId}/derivadas`,
      form
    );
  },
  duplicarDerivada: function (idMensurando, idDerivada, simbolo) {
    if (!simbolo)
      return CalculosApi.post()(
        `/FormulaMensurando/${idMensurando}/derivadas/${idDerivada}/duplicar`,
        { simbolo: null }
      );
    return CalculosApi.post()(
      `/FormulaMensurando/${idMensurando}/derivadas/${idDerivada}/duplicar`,
      simbolo
    );
  },
  excluirDerivada: function (idMensurando, idDerivada) {
    return CalculosApi.delete()(
      `/FormulaMensurando/${idMensurando}/derivada/${idDerivada}`
    );
  },
  publicar: function (id) {
    return CalculosApi.put()(`/FormulaMensurando/${id}/revisao/publicar`);
  },
  criarNovaRevisao: function (id) {
    return CalculosApi.post()(`/FormulaMensurando/${id}/revisao`);
  },
  excluirRevisao: function (idMensurando, idRevisao) {
    return CalculosApi.delete()(
      `/FormulaMensurando/${idMensurando}/revisao/${idRevisao}`
    );
  },
};

export default FormulaService;
